import { render, staticRenderFns } from "./activities-add.vue?vue&type=template&id=3e0b9666&scoped=true"
import script from "./activities-add.vue?vue&type=script&lang=js"
export * from "./activities-add.vue?vue&type=script&lang=js"
import style0 from "./activities-add.vue?vue&type=style&index=0&id=3e0b9666&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b9666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0b9666')) {
      api.createRecord('3e0b9666', component.options)
    } else {
      api.reload('3e0b9666', component.options)
    }
    module.hot.accept("./activities-add.vue?vue&type=template&id=3e0b9666&scoped=true", function () {
      api.rerender('3e0b9666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/activities/activities-add.vue"
export default component.exports